export const genericAlert = 'genericAlert';
export const successAlert = 'successAlert';
export const nondismissableAlert = 'nonDismissableAlert';

export default {
  genericAlert,
  successAlert,
  nondismissableAlert,
};
